import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Modal, Table
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import axios from "axios";
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import _ from 'lodash';
import * as FileSaver from "file-saver";
import LoadingOverlay from 'react-loading-overlay';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSVNew from '../../../Common/exportcsvnew';

var url = window.location.hostname;
var port = window.location.port;




class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.processData = this.processData.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.SuccessConfirmoktoggle = this.SuccessConfirmoktoggle.bind(this);
    
    this.accessCookie = this.accessCookie.bind(this);
    this.toggleInvalidModal = this.toggleInvalidModal.bind(this);
    this.toggleInvalidModalCancel = this.toggleInvalidModalCancel.bind(this);
    /*this.ExcelDateToJSDate = this.ExcelDateToJSDate.bind(this);*/
    /*this.toShortFormat = this.toShortFormat.bind(this);*/
    this.state = {
	  loading_overlay: false,	
	  outer_carton_putaway_header: [
        { "S.No.":"","Document Type": "", "GRN Number": "", "GRN Line Number": "", "Basepack Code": "","Basepack Description": "","CBU Code": "","SKU7 Code": "","LB SKU ID": "","LB SKU Product Name": "", "PKD": "", "Batch": "", "MRP": "", "UPC": "" ,"Received ICLD Quantity":"","Tester Quantity":"","Actual Received Loose Qty":"","In ICLD Short Eaches":"","Reason for in ICLD Short":"","Tester Flag":"","STN Date":"","STN Number":"","Storage Type":"","Fast Moving":"","Crate ID":"","GRN Date Time":"","Remarks":""},
      ],
	  sales_return_putaway_header: [
        { "S.No.":"","Document Type": "", "GRN Number": "", "GRN Line Number": "", "Basepack Code": "","Basepack Description": "","CBU Code": "","SKU7 Code": "","LB SKU ID": "","LB SKU Product Name": "", "PKD": "", "Batch": "", "MRP": "", "UPC": "" ,"Received ICLD Quantity":"","Tester Quantity":"","Actual Received Loose Qty":"","In ICLD Short Eaches":"","Reason for in ICLD Short":"","Tester Flag":"","STN Date":"","STN Number":"","Storage Type":"","Fast Moving":"","Crate ID":"","GRN Date Time":"","Remarks":""},
      ],
      stock_transfer_putaway_header: [
        { "S.No.":"","Document Type": "", "GRN Number": "", "GRN Line Number": "", "Basepack Code": "","Basepack Description": "","CBU Code": "","SKU7 Code": "","LB SKU ID": "","LB SKU Product Name": "", "PKD": "", "Batch": "", "MRP": "", "UPC": "" ,"Received ICLD Quantity":"","Tester Quantity":"","Actual Received Loose Qty":"","In ICLD Short Eaches":"","Reason for in ICLD Short":"","Tester Flag":"","STN Date":"","STN Number":"","Storage Type":"","Fast Moving":"","Crate ID":"","GRN Date Time":"","Remarks":""},
      ],	  
      responseModal: false,
	  responseModalMsg: null,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      modal: false,
      modalFailed: false,
      showAllItem: false,
      showInvalidItem: false,
      showInvalidModal: false,
      showInvalidModal: false,
      showProceedbtn: false,
      SuccessConfirmmodal: false,
      loadingconfirmbtn: false,
      restrictProcess: false,
      disabledBtn: false,
      loading: false,
      dateNewVal: '',
      stn_date_formate: '',
	  
	  
      table_header: ['GRN Number' , 'GRN Line Number' , 'Basepack Code', 'Basepack Description' , 'CBU Code', 'SKU7 Code' , 'LB SKU ID' , 'LB SKU Product Name' , 'PKD' , 'Batch' , 'MRP', 'UPC' , 'Received ICLD Quantity' , 'Tester Quantity' , 'Tester Flag' , 'STN Date' , 'STN Number' , 'Storage Type' , 'Fast Moving', 'Crate ID' ,'GRN Date Time', 'Remarks' ],
      validation: {
        "Bin Master": {
          "GRN Number": "string",
          "GRN Line Number": "number",
          "Basepack Code": "string",
          "Level": "number",
          "Rack": "number",
          "Rack type": "string",
          "Storage type": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },
      },
    };
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41" + ":8090";

      }else{
        url= window.location.hostname + port;
      }

      var cookieUsername = this.getCookie('token');
      var Location = this.getCookie('selectedLocation');
      var username = this.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: Location
      })

      localStorage.setItem('userName' , username);
    }



   

  accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        } 


        getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }





  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));

    
  }

  SuccessConfirmtoggle() {
    this.setState(prevState => ({ SuccessConfirmmodal: !prevState.SuccessConfirmmodal }));

    
  }

  toggleInvalidModal() {
    this.setState(prevState => ({ showInvalidModal: !prevState.showInvalidModal }));
    
  }

  toggleInvalidModalCancel(){
    this.fileInput.value = "";
    $(".upload_error").css('display', 'none');
    $(".upload_success").css('display', 'none');
    this.setState({
      showInvalidModal: false
    })
  }

  SuccessConfirmoktoggle(){
    this.setState({
      SuccessConfirmmodal: false
    })
    window.location.href="/putaway/printPutaway";
  }

  processData(){

    this.setState({
      loadingconfirmbtn: true,
      disabledBtn: true
    })

      var arr = []
     console.log(JSON.stringify(this.state.data.length));
    
      
      for(var i = 0; i < this.state.data.length; i++) {
          
          console.log(this.state.data[i]['GRN Number']);
        var orderData  = {};
          orderData['GRNNumber'] = this.state.data[i]['GRN Number'];
          orderData['GNRLineNumber'] = this.state.data[i]['GRN Line Number'];
          orderData['basePackCode'] = this.state.data[i]['Basepack Code'];
          orderData['basePackDescription'] = this.state.data[i]['Basepack Description'];
          orderData['cbuCode'] = this.state.data[i]['CBU Code'];
          orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
          orderData['lbSKUid'] = this.state.data[i]['LB SKU ID'];
          orderData['lbSKUProductName'] = this.state.data[i]['LB SKU Product Name'];
          orderData['pkd'] = this.state.data[i]['PKD'];
          orderData['batch'] = this.state.data[i]['Batch'];
          orderData['mrp'] = this.state.data[i]['MRP'];
          orderData['upc'] = this.state.data[i]['UPC'];
          orderData['receivedICLDQuantity'] = this.state.data[i]['Received ICLD Quantity'];
          orderData['testerQuantity'] = this.state.data[i]['Tester Quantity'];
          orderData['testerFlag'] = this.state.data[i]['Tester Flag'];
          orderData['stnDate'] = this.state.data[i]['STN Date'];
          orderData['stnNumber'] = this.state.data[i]['STN Number'];
          orderData['storageType'] = this.state.data[i]['Storage Type'];
          orderData['fastMoving'] = this.state.data[i]['Fast Moving'];
          if (this.state.data[i]['Crate ID'] === undefined) {
            orderData['crateId'] = "";
          }else{
            orderData['crateId'] = this.state.data[i]['Crate ID'];
          }
          
          orderData['grnDateTime'] = this.state.data[i]['GRN Date Time'];

          if (this.state.data[i]['Remarks'] === undefined) {
            orderData['remarks'] = "";
          }else{
            orderData['remarks'] = this.state.data[i]['Remarks'];
          }
          
          /*orderData['remarks'] = 'dfghjk';*/

          
          arr.push(orderData);
      }

      console.log(arr);
      console.log(this.state.table_header.length);

      /*this.state.data.forEach(function(jsonobj){
            this.state.table_header.forEach(function(header_text){
              if (jsonobj[header_text] == undefined){
                jsonobj[header_text] = "";
            }
          });
      });*/


      /*if (this.state.responseFailLBSKUData.failure_response.length>0) {
          $(".error_file_uploaded").css('display', 'block');
        }else{
          
       $(".error_file_uploaded").css('display', 'none');*/


      const payload = {
        arr_data: this.state.data,
        location: this.state.selectedLocation,
        create: true,
  };
  addAnalytics('Upload GRN', 'Confirm Uploaded GRN Data');

API.post('/picking/inv_upload/v1/', { param: payload })
      .then((response) =>  {

        /*let data = this.state.data
        response.data.map(item => {
          if(!item.status){
            const index = _.findIndex(data, dataItem => item.lb_sku_id == dataItem['LB SKU ID'])
            data[index].error = item.message
          }
        })*/

        /*alert("Successfully Created");*/
        this.setState({
          responseFailLBSKUData: response.data,
          responseSuccessLBSKUData: response.data,
          /*data: data,*/
         /* showInvalidItem: true,*/
          modalFailed: false,
          loadingconfirmbtn: false
        })

        this.SuccessConfirmtoggle();

        /*window.location.href="/putaway/printPutaway";*/ 

        console.log(this.state.data);
      })
      .catch(function (error) {
        
    });
    /*}*/


  }

  togglePressCancel(){
      this.setState({
        showInvalidItem: false,
        modalFailed: false,
      })

  }


  


 /*handleFile() {
    console.log('dfghjmk');
    
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
 
    reader.onload = (e) => {
      
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
      
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      
      const data = XLSX.utils.sheet_to_json(ws);
     
      this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
        console.log(JSON.stringify(this.state.data, null, 2));
      });
 
    };*/
 
    /* var arr = []
     console.log(JSON.stringify(this.state.data.length));
    
      
      for(var i = 0; i < this.state.data.length; i++) {
          
          console.log(this.state.data[i]['GRN Number']);
        var orderData  = {};
          orderData['GRNNumber'] = this.state.data[i]['GRN Number'];
          orderData['GNRLineNumber'] = this.state.data[i]['GRN Line Number'];
          orderData['basePackCode'] = this.state.data[i]['Basepack Code'];
          orderData['basePackDescription'] = this.state.data[i]['Basepack Description'];
          orderData['cbuCode'] = this.state.data[i]['CBU Code'];
          orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
          orderData['lbSKUid'] = this.state.data[i]['LB SKU ID'];
          orderData['lbSKUProductName'] = this.state.data[i]['LB SKU Product Name'];
          orderData['pkd'] = this.state.data[i]['PKD'];
          orderData['batch'] = this.state.data[i]['Batch'];
          orderData['mrp'] = this.state.data[i]['MRP'];
          orderData['upc'] = this.state.data[i]['UPC'];
          orderData['receivedICLDQuantity'] = this.state.data[i]['Received ICLD Quantity'];
          orderData['testerQuantity'] = this.state.data[i]['Tester Quantity'];
          orderData['testerFlag'] = this.state.data[i]['Tester Flag'];
          orderData['stnDate'] = this.state.data[i]['STN Date'];
          orderData['stnNumber'] = this.state.data[i]['STN Number'];
          orderData['storageType'] = this.state.data[i]['Storage Type'];
          orderData['fastMoving'] = this.state.data[i]['Fast Moving'];
          orderData['crateId'] = this.state.data[i]['Crate ID'];
          orderData['grnDateTime'] = this.state.data[i]['GRN Date Time'];
          orderData['remarks'] = 'dfghjk';

          
          arr.push(orderData);
      }

      console.log(arr);


      axios
    .post(('http://3.215.84.36:8088/picking/inv_upload/v1/' , 

      {

        arr_data: arr,
        location: 'bhi',
        create: false,
      },

     {
       headers: {
            'Content-Type': 'application/json'
            
          } 

     }
     

     )
      .then((response) =>  {

        console.log(response);
       

      })
      .catch(function (error) {
        
        
    });*/
  /*}*/


  
  

/*toShortFormat(){
  var month_names =["Jan","Feb","Mar",
                      "Apr","May","Jun",
                      "Jul","Aug","Sep",
                      "Oct","Nov","Dec"];
    
    var day = this.getDate();
    var month_index = this.getMonth();
    var year = this.getFullYear();
    
    var stn_date=  "" + day + "-" + month_names[month_index] + "-" + year;
    this.setState({
      stn_date_formate : stn_date,
    })
}*/

handleFile() {
    /* Boilerplate to set up FileReader */
    var ref = this;
	if(this.state.file.name === undefined || this.state.file.name === null){
		this.setState({
			responseModal: true,
			responseModalMsg: "Select at least one File"
		});
		return false;
    }
    if (this.state.restrictProcess == true) {
      this.setState({
        showInvalidModal: true,
		loading_overlay: true,
      })

    }else{

    
    

    this.setState({
      loading: true
    })
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
 
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true, cellDates: true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws,{raw:false,dateNf: 'YYYY-MM-DD'})
      
      // const formattedData = data.map(item => {
      //   if(item['stnDate'])
      // })
      /* Update state */
      this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
       
        /*let invalidItems = this.state.data.filter(item => !this.validateItem(item))*/



        var arr = []
    
      
      for(var i = 0; i < this.state.data.length; i++) {
        // var backToDate = new Date(this.state.data[i]['STN Date']);
        // console.log(backToDate);
        // this.ExcelDateToJSDate(this.state.data[i]['STN Date']);
        /*this.toShortFormat(this.state.dateNewVal)*/

        /*const date = this.state.dateNewVal;
        const formattedDate = date.toLocaleDateString('en-GB', {
          day: 'numeric', month: 'short', year: 'numeric'
        }).replace(/ /g, '-');
        console.log(formattedDate);*/
         

       /* var utc_days  = Math.floor(this.state.data[i]['STN Date'] - 25569);
       var utc_value = utc_days * 86400;                                        
       var date_info = new Date(utc_value * 1000);

       var fractional_day = this.state.data[i]['STN Date'] - Math.floor(this.state.data[i]['STN Date']) + 0.0000001;

       var total_seconds = Math.floor(86400 * fractional_day);

       var seconds = total_seconds % 60;

       total_seconds -= seconds;

       var hours = Math.floor(total_seconds / (60 * 60));
       var minutes = Math.floor(total_seconds / 60) % 60;

       return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);


    var month_names =["Jan","Feb","Mar",
                      "Apr","May","Jun",
                      "Jul","Aug","Sep",
                      "Oct","Nov","Dec"];
    
    var day = this.getDate();
    var month_index = this.getMonth();
    var year = this.getFullYear();
    
    var dateFormate = day + "-" + month_names[month_index] + "-" + year;
          */
          
        var orderData  = {};
          orderData['GRNNumber'] = this.state.data[i]['GRN Number'];
          orderData['GNRLineNumber'] = this.state.data[i]['GRN Line Number'];
          orderData['basePackCode'] = this.state.data[i]['Basepack Code'];
          orderData['basePackDescription'] = this.state.data[i]['Basepack Description'];
          orderData['cbuCode'] = this.state.data[i]['CBU Code'];
          orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
          orderData['lbSKUid'] = this.state.data[i]['LB SKU ID'];
          orderData['lbSKUProductName'] = this.state.data[i]['LB SKU Product Name'];
          orderData['pkd'] = this.state.data[i]['PKD'];
          orderData['batch'] = this.state.data[i]['Batch'];
          orderData['mrp'] = this.state.data[i]['MRP'];
          orderData['upc'] = this.state.data[i]['UPC'];
          orderData['receivedICLDQuantity'] = this.state.data[i]['Received ICLD Quantity'];
          orderData['testerQuantity'] = this.state.data[i]['Tester Quantity'];
          orderData['testerFlag'] = this.state.data[i]['Tester Flag'];

          orderData['stnDate'] = this.state.data[i]['STN Date'];
          orderData['stnNumber'] = this.state.data[i]['STN Number'];
          orderData['storageType'] = this.state.data[i]['Storage Type'];
          orderData['fastMoving'] = this.state.data[i]['Fast Moving'];
          if (this.state.data[i]['Crate ID'] === undefined) {
            orderData['crateId'] = "";
          }else{
            orderData['crateId'] = this.state.data[i]['Crate ID'];
          }
          
          orderData['grnDateTime'] = this.state.data[i]['GRN Date Time'];

          if (this.state.data[i]['Remarks'] === undefined) {
            orderData['remarks'] = "";
          }else{
            orderData['remarks'] = this.state.data[i]['Remarks'];
          }
          
          /*orderData['remarks'] = 'dfghjk';*/

          
          arr.push(orderData);
      }
                      addAnalytics('Upload GRN', 'Upload GRN Data');

      /*this.state.data.forEach(function(jsonobj){
            this.state.table_header.forEach(function(header_text){
              if (jsonobj[header_text] == undefined){
                jsonobj[header_text] = "";
            }
          });
      });*/
    
      const payload = {
  arr_data: this.state.data,
          location: this.state.selectedLocation,
          create: false,
  };

API.post('/picking/inv_upload/v1/', { param: payload })('http://'+url+'' , 

      {

        
      },

     {
       headers: {
            'Content-Type': 'application/json',
            'Authorization' : this.state.userName
            
          } 

     }
     

     )
      .then((response) =>  {

        
        let data = this.state.data
        response.data.failure_response.map((item,itemindex) => {
          
          if(item.status === false){
            console.log(itemindex,item.status,item["status"]);
            const index = _.findIndex(data, dataItem => item.lb_sku_id+item.sr_no == dataItem['LB SKU ID']+dataItem['S.No.']);
            		
            data[index].error = item.message
            
          }
        })
        
        
        if (response.data.failure_response.length>0) {
          this.toggleFailed();
          
          this.setState({
            showError: true,
          })
        }else{
          this.toggle();
          
        }

        if (response.data.failure_response.length>0) {
          console.log(response.data.failure_response.length);
          this.setState({
            showProceedbtn: false
          })

          console.log(this.state.showProceedbtn);
        }else if (response.data.failure_response.length===0){
          console.log(response.data.failure_response.length);
          console.log("sdfghjsdfghjdfg");
          this.setState({
            showProceedbtn: true
          })
        }
        

        this.setState({
          responseFailLBSKUData: response.data,
          loading: false,
          responseSuccessLBSKUData: response.data,
          data: data,
          showAllItem: true,

        })



      })
      .catch(function (error) {
        console.log("ERRR -",error.response.status);
                if(parseInt(error.response.status) === 500){
					var msg = "Data is missing";
				}else{
					var msg = "Something went wrong in API";
				}
				ref.setState({
					loading: false,
					responseModal: true,
					responseModalMsg: msg,
                     loading_overlay: false,
				});
    });



      });
 
    };
 
    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    };


    }
  }




  
  handleChange(evt) {
    const files = evt.target.files;
    if (files && files[0]) {
		this.setState({ 
		file: files[0] 
		})
	}else{
		this.setState({ 
		loading_overlay: false,
        file:{}
		})
        $(".upload_success").css('display', 'none');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
        return false;
	};

    var file1 = evt.target.value
    var fileArray1 = evt.target.value.split('.')
    var extension1 = fileArray1[fileArray1.length - 1]
	if (document.getElementById("my_file_input") !== null) {
      document.getElementById("my_file_input").style.color = "";
      document.getElementById("tester_label").style.display = "none";
    }
    if(extension1 != 'xlsx' && extension1 != 'csv' && extension1 != 'xls'){
    
      $(".upload_error").css('display', 'block');
      $(".upload_success").css('display', 'none');
      this.setState({
        restrictProcess: true
      })

    }else {
      $(".upload_success").css('display', 'block');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
       this.setState({
        restrictProcess: false
      })
    }
  };

  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  responseModalToggle = () => {
	this.setState({
		responseModal: !this.state.responseModal
	});
  }
  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { SuccessConfirmmodal, showInvalidModal } = this.state;

    return (
      <Col xl={12}>
	  {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text"></h5>
              
            </div>
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div className="form__form-group col-xl-6">
               
                <div className="form__form-group-field">
				<div className="row">
                  <div className="col-xl-12" style={{border: "1px solid #ced4da"}}>
                  <input  style={{paddingTop: 8,  height: 38,color: "transparent",width:"56%",border:"0px"}}
                    name="defaultInput"
                    component="input"
                    type="file"
                    placeholder="Default Input"
                    id="my_file_input" 
                    onChange={this.handleChange} 
                    ref={ref=> this.fileInput = ref}
                  />
				  <label for="files" id="tester_label">
                    Select and Upload GRN sheet
                  </label>
                  
                  </div>
				  <div className="col-xl-12" style={{marginTop:"10px"}}>
                  <span style={{display: 'none' , color:'red'}} className="upload_error"> Invalid file format. Please select .xls, .xlsx, .csv file format </span>
                  <span style={{display: 'none' , color:'green', marginTop: 8}} className="upload_success"> Valid file format </span>
                  </div>
				  </div>
                  
                </div>
                
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                    <Button className="btn-sm button_enable " style={{borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff',textTransform:"capitalize"}} id="button_enable" onClick={this.handleFile} >
                    {this.state.loading && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }

                    Proceed
                    </Button>
                </ButtonToolbar>
              </div>
            
            </form>
			
			<div className="notes" style={{paddingTop:'0px',paddingLeft:"15px"}}>		
              <p style={{marginBottom: '13px',fontSize: '15px'}}><b>Note</b> : 1. Use Stock Transfer sample template to upload putaway sheet for stock transfer.&nbsp;&nbsp;&nbsp;<span style={{
                    backgroundColor: "#fff",
                    color: "rgb(112, 187, 253)",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
					cursor:"pointer"
                  }}
				  onClick={(e) =>
                    exportToCSVNew(
                      this.state.stock_transfer_putaway_header,
                      "Stock Transfer Template"
                    )
                  }>Sample Template</span></p>
			  <p style={{marginBottom: '13px',fontSize: '15px',paddingLeft:'47px'}}>2. Use Sales Return sample template to upload putaway sheet for Sales Return.&nbsp;&nbsp;&nbsp;<span style={{
                    backgroundColor: "#fff",
                    color: "rgb(112, 187, 253)",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
					cursor:"pointer"
                  }}
				  onClick={(e) =>
                    exportToCSVNew(
                      this.state.sales_return_putaway_header,
                      "Sales Return Template"
                    )
                  }>Sample Template</span></p>
			  <p style={{marginBottom: '13px',fontSize: '15px',paddingLeft:'47px'}}>3. Use Outer Carton sample template to upload putaway sheet for Outer Carton.&nbsp;&nbsp;&nbsp;<span style={{
                    backgroundColor: "#fff",
                    color: "rgb(112, 187, 253)",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
					cursor:"pointer"
                  }}
				  onClick={(e) =>
                    exportToCSVNew(
                      this.state.outer_carton_putaway_header,
                      "Outer Carton Template"
                    )
                  }>Sample Template</span></p>
			 </div> 
			 
          </CardBody>


          {
            this.state.showInvalidItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>LB SKU ID</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailLBSKUData.failure_response.length>0 && (
                      this.state.responseFailLBSKUData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessLBSKUData.success_response.length>0 && (
                      this.state.responseSuccessLBSKUData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }



          {
            this.state.showAllItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div className="table_header">
                   <ButtonToolbar className="form__button-toolbar">
                      {this.state.showProceedbtn && (
                      <Button color="primary" disabled={this.state.disabledBtn} className="btn-sm show_confirm_button" onClick={this.processData} type="submit">
                      {this.state.loadingconfirmbtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    } 
                      Confirm</Button>
                      )}
                    </ButtonToolbar>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>Response </th>
                        <th>GRN Number</th>
                        <th>GRN Line Number</th>
                        <th>Basepack Code</th>
                        <th>Basepack Description</th>
                        <th>CBU Code</th>
                        <th>SKU7 Code</th>
                        <th>LB SKU ID</th>
                        <th>LB SKU Product Name</th>
                        <th>PKD</th>
                        <th>Batch</th>
                        <th>MRP</th>
                        <th>UPC</th>
                        <th>Received ICLD Quantity</th>
                        <th>Tester Quantity</th>
                        <th>Loose Quantity</th>
                        <th>Tester Flag</th>
                        <th>STN Date</th>
                        <th>Storage Type</th>
                        <th>Fast Moving </th>
                        <th>Crate ID</th>
                        <th>GRN Date Time </th>
                        <th>Remarks </th>
                       
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                      {
                      
                      this.state.data.map((item, index) => (
                        <tr>
                          { item['error'] ? (
                            <td style={{"backgroundColor": "red", color: '#fff'}}> {item['error']} </td>

                            ) : (
                            <td style={{"backgroundColor": "green", color: '#fff'}}> No Error </td>

                            )
                          }
                          <td>{item['GRN Number']}</td>
                          <td>{item['GRN Line Number']}</td>
                          <td>{item['Basepack Code']}</td>
                          <td>{item['Basepack Description']}</td>
                          <td>{item['CBU Code']}</td>
                          <td>{item['SKU7 Code']}</td>
                          <td>{item['LB SKU ID']}</td>
                          <td>{item['LB SKU Product Name']}</td>
                          <td>{item['PKD']}</td>
                          <td>{item['Batch']}</td>
                          <td>{item['MRP']}</td>
                          <td>{item['UPC']}</td>
                          <td>{item['Received ICLD Quantity']}</td>
                          <td>{item['Tester Quantity']}</td>
                          <td>{item['Loose Quantity']}</td>
                          <td> {item['Tester Flag']} </td>
                          <td>{item['STN Date']}</td>
                          <td>{item['Storage Type']}</td>
                          <td>{item['Fast Moving']}</td>
                          <td>{item['Crate ID']}</td>
                          <td>{item['GRN Date Time']}</td>
                          
                          <td> {item['Remarks']} </td>

                          
                          
                          
                        </tr>
                      ))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }










        </Card>



        <Modal
          isOpen={showInvalidModal}
          toggle={this.toggleInvalidModal}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4> Please Select a valid file format. <br/> (.xls , xlsx , csv) </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.toggleInvalidModalCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>




        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.toggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
             <span className="lnr lnr-cross-circle modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>This file contains some errors, Please Upload a valid file. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button  className="modal_cancel"  onClick={this.togglePressCancel}>Cancel</button>
            <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12, display: 'none'}} className="modal_ok"  onClick={this.togglePressCancel}>Procced</Button>
          </ButtonToolbar>
        </Modal>



        <Modal
          isOpen={SuccessConfirmmodal}
          toggle={this.SuccessConfirmtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.SuccessConfirmtoggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.SuccessConfirmoktoggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>
		
		<Modal
          isOpen={this.state.responseModal}
          toggle={this.responseModalToggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.responseModalToggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>{this.state.responseModalMsg}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.responseModalToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));